import {
  AdamCapponi,
  AlinPatron,
  CharlesBurkeCowley,
  DariaShapira,
  DavidDolch,
  DenisMezer,
  GregoryTheuret,
  IgorPapo,
  IvanGalkin,
  JalolMurzakhmetov,
  JamesFuhrman,
  JonWilburn,
  JosephDiMelis,
  JoshuaStewart,
  MattLutton,
  MichaelGrives,
  MihaelaPoiata,
  PaulBurchell,
  RimaNemtu,
  RobertWood,
  SergeyBogutsky,
  SergheiBusmachi,
  TimGables,
  ToddNelson,
  TrevorClerico,
  TristaParry,
  TroyWilson,
} from '../../images/about-us/redesign';

const employees = [
  {
    title: 'Leadership',
    infoList: [
      {
        image: SergheiBusmachi,
        title: 'Serghei Busmachiu',
        text: 'Chief Executive Officer',
        popupContent: {
          name: 'Serghei Busmachiu',
          position: 'Chief Executive Officer',
          description:
            'Serghei Busmachiu, with a strategic vision and leadership expertise, has founded and currently leads four successful companies: Utilities One, Moldcable, Energy5, and US Software Solutions. He executes profound industry insights to drive sustainable company growth and ensures effective management of high-performing teams.',
        },
      },
      {
        image: JosephDiMelis,
        title: 'Joseph DiMelis',
        text: 'Executive Vice President and COO',
        popupContent: {
          name: 'Joseph DiMelis',
          position: 'Executive Vice President and COO',
          description:
            "Joseph DiMelis's career spans over thirty years in the Telecom industry and has significantly impacted major enterprises, including AT&T, Time Warner Cable Inc., Charter Communications, and Ziply Fiber. His expertise in strategic planning, cost management, and team development has consistently delivered breakthrough performance and operational improvements.",
        },
      },
      {
        image: AlinPatron,
        title: 'Alin Patron',
        text: 'Chief Strategy Officer',
        popupContent: {
          name: 'Alin Patron',
          position: 'Chief Strategy Officer',
          description:
            'Alin Patron, leveraging a profound background in Business Administration and Management, serves as a driving force behind development at Utilities One. Acknowledged for his meticulous attention to detail and outstanding problem-solving abilities, Alin has previously held the prominent role of Business Development Executive.',
        },
      },
      {
        image: IvanGalkin,
        title: 'Ivan Galkin',
        text: 'Vice President Fulfillment & Installation',
        popupContent: {
          name: 'Ivan Galkin',
          position: 'Vice President Fulfillment & Installation',
          description:
            "Ivan Galkin's expertise evolved from Lead Sales Manager to Senior Manager promotion within Lexus Inc. company, then Anti-Crisis management at Porsche Inc., and now as a remarkable Vice President at Utilities One, where he grew from operations technician up to VP, proofing exceptional ability in addressing challenges and adeptly resolving complex situations.",
        },
      },
      {
        image: JoshuaStewart,
        title: 'Joshua Stewart',
        text: 'Vice President & General Manager - OSP Construction',
        popupContent: {
          name: 'Joshua Stewart',
          position: 'Vice President & General Manager - OSP Construction',
          description: '',
        },
      },
      {
        image: MichaelGrives,
        title: 'Michael Grives',
        text: 'Vice President & General Manager - OSP Construction',
        popupContent: {
          name: 'Michael Grives',
          position: 'Vice President & General Manager - OSP Construction',
          description: '',
        },
      },
      {
        image: MattLutton,
        title: 'Matt Lutton',
        text: 'Vice President & General Manager - OSP Construction',
        popupContent: {
          name: 'Matt Lutton',
          position: 'Vice President & General Manager - OSP Construction',
          description: '',
        },
      },
      {
        image: IgorPapo,
        title: 'Igor Papo',
        text: 'Vice President & General Manager - OSP Construction',
        popupContent: {
          name: 'Igor Papo',
          position: 'Vice President & General Manager - OSP Construction',
          description: '',
        },
      },
      {
        image: MihaelaPoiata,
        title: 'Mihaela Poiata',
        text: 'Chief Accounting Officer',
        popupContent: {
          name: 'Mihaela Poiata',
          position: 'Chief Accounting Officer',
          description: '',
        },
      },
      {
        image: DariaShapira,
        title: 'Daria Shapira',
        text: 'Chief of Staff',
        popupContent: {
          name: 'Daria Shapira',
          position: 'Chief of Staff',
          description: '',
        },
      },
    ],
  },
  {
    title: 'Operations Team',
    infoList: [
      {
        image: DenisMezer,
        title: 'Denis Mezer',
        text: 'Senior Director - Construction Field Services & Splicing',
        project: 'OSP Construction',
      },
      {
        image: JamesFuhrman,
        title: 'James Fuhrman',
        text: 'Senior Director - OSP Construction',
      },
      {
        image: RobertWood,
        title: 'Robert Wood',
        text: 'Senior Director - Special Projects',
      },
      {
        image: GregoryTheuret,
        title: 'Gregory Theuret',
        text: 'Director - OSP Construction',
      },
      {
        image: TrevorClerico,
        title: 'Trevor Clerico',
        text: 'Director - OSP Construction',
      },
      {
        image: TroyWilson,
        title: 'Troy Wilson',
        text: 'Director - OSP Construction',
      },
      {
        image: ToddNelson,
        title: 'Todd Nelson',
        text: 'Director - OSP Construction',
      },
      {
        image: AdamCapponi,
        title: 'Adam Capponi',
        text: 'Director - OSP Construction',
      },
      {
        image: PaulBurchell,
        title: 'Paul Burchell',
        text: 'Director - OSP Construction',
      },
      {
        image: JalolMurzakhmetov,
        title: 'Jalol Murzakhmetov',
        text: 'Director - Fiber Splicing',
      },
    ],
  },
  {
    infoList: [
      {
        image: TimGables,
        title: 'Tim Gables',
        text: 'Senior Director of Engineering',
        project: 'OSP Engineering',
      },
      {
        image: JonWilburn,
        title: 'Jon Wilburn',
        text: 'Director - Engineering Support Services',
      },
      {
        image: RimaNemtu,
        title: 'Rima Nemtu',
        text: 'Director - Consulting Services',
        project: 'Consulting',
      },
      {
        image: CharlesBurkeCowley,
        title: 'Charles Burke Cowley',
        text: 'Director - Construction Support Services',
        project: 'pmo',
      },
      {
        image: SergeyBogutsky,
        title: 'Sergey Bogutsky',
        text: 'Director of Human Resources',
        project: 'Hr',
      },
      {
        image: DavidDolch,
        title: 'David Dolch',
        text: 'Director of Business Process & Organizational Excellence',
        project: 'Operational Excellence',
      },
      {
        image: TristaParry,
        title: 'Trista Parry',
        text: 'Director of Business Development',
        project: 'Business Development',
      },
    ],
  },
];

export default employees;
